import { defineStore } from "pinia";

export const useUserCustomizationStore = defineStore(
  "userCustomization",
  {
    state: () => ({
      // 用戶群組配置
      userGroup: "default", // 預設為 default，等待 API 回傳後更新
      // B2C 用戶的資源分類配置
      b2cResourceConfig: {
        readingListening: {
          display: "Reading & Listening",
          type: "book",
          icon: "dripicons-book",
          color: "#1f4840",
        },
        videoSpeaking: {
          display: "Video & Speaking",
          type: "video",
          icon: "dripicons-video",
          color: "#faaf3d",
        },
      },
      // 保存用戶選擇的資源資訊
      selectedResource: null,
      // 保存 B2C 用戶選擇的分類資訊
      selectedB2CCategory: null,
      // 保存 B2C 用戶選擇分類下的所有資源列表
      selectedB2CResources: [],
      customizationConfig: {
        // 預設配置 - 顯示所有功能
        default: {
          navItems: [
            {
              path: "/msu/home",
              name: "home",
              icon: "dripicons-home",
              tag: "Home",
              visible: true,
            },
            {
              path: "/msu/homework",
              name: "assignment",
              icon: "dripicons-graduation",
              tag: "Assignment",
              visible: true,
            },
            {
              path: "/msu/aispeech",
              name: "AI Speech",
              icon: "fa-solid fa-robot",
              tag: "AI Speech",
              visible: true,
            },
            {
              path: "/msu/daily-goal/*",
              name: "daily-task",
              icon: "dripicons-trophy",
              tag: "Daily Task",
              visible: true,
            },
            {
              path: "/msu/daily-login",
              name: "login-record",
              icon: "dripicons-calendar",
              tag: "Login Record",
              visible: true,
            },
          ],
          taskCards: [
            {
              title: "assignment",
              bg: "teacher",
              bgColor: "#1f4840",
              hint: "totalAssignmentNum",
              link: "/msu/homework",
              visible: true,
            },
            {
              title: "echo-valley",
              bg: "moutain",
              bgColor: "#faaf3d",
              hint: "",
              link: "/msu/aispeech",
              visible: true,
            },
            {
              title: "daily-task-0",
              bg: "trophy",
              bgColor: "#5ea1d3",
              hint: "",
              link: "/msu/daily-goal/*",
              visible: true,
            },
          ],
          userCard: {
            btnItems: [
              {
                title: "parent",
                imageType: "Parent",
                link: "/parents-login/true",
                hint: "",
                visible: true,
              },
              {
                title: "achievement",
                imageType: "Achievement",
                link: "my-achievement",
                hint: "",
                visible: true,
              },
              {
                title: "award-0",
                imageType: "Award",
                link: "my-award",
                hint: "totalReward",
                visible: true,
              },
              {
                title: "dictionary",
                imageType: "MyVocab",
                link: "my-dictionary",
                hint: "",
                visible: true,
              },
            ],
            activities: {
              english: {
                visible: true,
                items: [1, 2, 3, 4, 5], // 顯示所有 English 活動
              },
              relax: {
                visible: true,
                items: [2, 3], // 顯示 Relax 活動
              },
            },
          },
        },
        // B2C 用戶群組配置
        B2C: {
          navItems: [
            {
              path: "/msu/home",
              name: "home",
              icon: "dripicons-home",
              tag: "Home",
              visible: true,
            },
            {
              path: "/msu/homework",
              name: "assignment",
              icon: "dripicons-graduation",
              tag: "Assignment",
              visible: false, // B2C 用戶不顯示 Assignment
            },
            {
              path: "/msu/aispeech",
              name: "AI Speech",
              icon: "fa-solid fa-robot",
              tag: "AI Speech",
              visible: false, // B2C 用戶不顯示 AI Speech
            },
            {
              path: "/msu/daily-goal/*",
              name: "daily-task",
              icon: "dripicons-trophy",
              tag: "Daily Task",
              visible: true,
            },
            {
              path: "/msu/daily-login",
              name: "login-record",
              icon: "dripicons-calendar",
              tag: "Login Record",
              visible: true,
            },
          ],
          taskCards: [
            {
              title: "assignment",
              bg: "teacher",
              bgColor: "#1f4840",
              hint: "totalAssignmentNum",
              link: "/msu/homework",
              visible: false, // B2C 用戶不顯示 Assignment 任務卡片
            },
            {
              title: "echo-valley",
              bg: "moutain",
              bgColor: "#faaf3d",
              hint: "",
              link: "/msu/aispeech",
              visible: false, // B2C 用戶不顯示 AI Speech 任務卡片
            },
            {
              title: "daily-task-0",
              bg: "trophy",
              bgColor: "#5ea1d3",
              hint: "",
              link: "/msu/daily-goal/*",
              visible: true,
            },
          ],
          userCard: {
            btnItems: [
              {
                title: "parent",
                imageType: "Parent",
                link: "/parents-login/true",
                hint: "",
                visible: true, // B2C 用戶在 sidebar 中顯示
              },
              {
                title: "achievement",
                imageType: "Achievement",
                link: "my-achievement",
                hint: "",
                visible: true, // B2C 用戶在 sidebar 中顯示
              },
              {
                title: "award-0",
                imageType: "Award",
                link: "my-award",
                hint: "totalReward",
                visible: true, // B2C 用戶在 sidebar 中顯示
              },
              {
                title: "dictionary",
                imageType: "MyVocab",
                link: "my-dictionary",
                hint: "",
                visible: true, // B2C 用戶在 sidebar 中顯示
              },
            ],
            activities: {
              english: {
                visible: true, // B2C 用戶在 sidebar 中顯示
                items: [1, 2, 3, 4, 5],
              },
              relax: {
                visible: true, // B2C 用戶在 sidebar 中顯示
                items: [2, 3],
              },
            },
          },
        },
      },
    }),

    getters: {
      // 獲取過濾後的導航項目
      filteredNavItems: (state) => {
        const config =
          state.customizationConfig[state.userGroup] ||
          state.customizationConfig.default;
        return config.navItems.filter((item) => item.visible);
      },

      // 檢查特定功能是否可用
      isAssignmentEnabled: (state) => {
        const config =
          state.customizationConfig[state.userGroup] ||
          state.customizationConfig.default;
        return (
          config.navItems.find((item) => item.path === "/msu/homework")
            ?.visible || false
        );
      },

      isAISpeechEnabled: (state) => {
        const config =
          state.customizationConfig[state.userGroup] ||
          state.customizationConfig.default;
        return (
          config.navItems.find((item) => item.path === "/msu/aispeech")
            ?.visible || false
        );
      },

      // 獲取過濾後的任務卡片項目
      filteredTaskCards: (state) => {
        const config =
          state.customizationConfig[state.userGroup] ||
          state.customizationConfig.default;
        return config.taskCards.filter((task) => task.visible);
      },

      // 獲取過濾後的 UserCard 按鈕項目
      filteredUserCardBtnItems: (state) => {
        const config =
          state.customizationConfig[state.userGroup] ||
          state.customizationConfig.default;
        return config.userCard.btnItems.filter((item) => item.visible);
      },

      // 獲取 UserCard 活動配置
      userCardActivities: (state) => {
        const config =
          state.customizationConfig[state.userGroup] ||
          state.customizationConfig.default;
        return config.userCard.activities;
      },

      // 獲取 B2C 用戶的資源分類選項
      b2cResourceOptions: (state) => {
        if (state.userGroup !== "B2C") return [];

        return [
          state.b2cResourceConfig.readingListening,
          state.b2cResourceConfig.videoSpeaking,
        ];
      },

      // 檢查是否為 B2C 用戶
      isB2CUser: (state) => {
        return state.userGroup === "B2C";
      },

      // 獲取正確的首頁路徑
      getHomePath: (state) => {
        if (state.userGroup === "B2C") {
          return "/msu/home-b2c";
        } else {
          return "/msu/home";
        }
      },

      // 獲取 B2C 用戶每個分類的資源統計
      b2cResourceStats: (state) => {
        if (state.userGroup !== "B2C") return {};

        // 這裡需要從外部傳入資源列表，所以我們在 actions 中處理
        return {
          readingListening: {
            count: 0,
            resources: [],
          },
          videoSpeaking: {
            count: 0,
            resources: [],
          },
        };
      },
    },

    actions: {
      // 設定用戶群組（由 API 調用）
      setUserGroup(group) {
        // 支援的用戶類型映射
        const supportedGroups = {
          B2C: "B2C",
          default: "default",
          enterprise: "default", // 企業用戶使用預設配置
          school: "default", // 學校用戶使用預設配置
        };

        const mappedGroup = supportedGroups[group] || "default";

        if (this.customizationConfig[mappedGroup]) {
          this.userGroup = mappedGroup;
          // 保存到 localStorage
          localStorage.setItem("userCustomization_userGroup", mappedGroup);

          // 如果不是 B2C 用戶，清理 B2C 相關的選擇資訊
          if (mappedGroup !== "B2C") {
            this.clearB2CSelection();
          }

          console.log(`User type "${group}" mapped to group: ${mappedGroup}`);
        } else {
          console.warn(`User group "${mappedGroup}" not found, using default`);
          this.userGroup = "default";
          localStorage.setItem("userCustomization_userGroup", "default");

          // 清理 B2C 相關的選擇資訊
          this.clearB2CSelection();
        }
      },

      // 清理 B2C 用戶的選擇資訊
      clearB2CSelection() {
        this.selectedB2CCategory = null;
        this.selectedB2CResources = [];
        this.selectedResource = null;

        // 清理 localStorage
        localStorage.removeItem("userCustomization_selectedB2CCategory");
        localStorage.removeItem("userCustomization_selectedB2CResources");
        localStorage.removeItem("userCustomization_selectedResource");

        console.log("B2C 選擇資訊已清理");
      },

      // 設定用戶選擇的資源
      setSelectedResource(resource) {
        this.selectedResource = resource;
        // 保存到 localStorage
        localStorage.setItem(
          "userCustomization_selectedResource",
          JSON.stringify(resource)
        );
      },

      // 設定 B2C 用戶選擇的分類和相關資源
      setSelectedB2CCategory(category, resources) {
        this.selectedB2CCategory = category;
        this.selectedB2CResources = resources;

        // 保存到 localStorage
        localStorage.setItem(
          "userCustomization_selectedB2CCategory",
          JSON.stringify(category)
        );
        localStorage.setItem(
          "userCustomization_selectedB2CResources",
          JSON.stringify(resources)
        );

        console.log(
          "B2C 分類已保存:",
          category.display,
          "包含",
          resources.length,
          "個資源"
        );
      },

      // 過濾 B2C 用戶的資源列表（排除 AESOP Fables）
      filterB2CResources(resources) {
        if (this.userGroup !== "B2C") return resources;

        return resources.filter(
          (resource) => resource.display !== "AESOP Fables"
        );
      },

      // 根據類型獲取對應的資源
      getResourcesByType(resources, type) {
        return resources.filter((resource) => resource.type === type);
      },

      // 計算 B2C 用戶每個分類的資源統計
      calculateB2CResourceStats(resources) {
        if (this.userGroup !== "B2C") return {};

        const filteredResources = this.filterB2CResources(resources);

        return {
          readingListening: {
            count: this.getResourcesByType(filteredResources, "book").length,
            resources: this.getResourcesByType(filteredResources, "book"),
          },
          videoSpeaking: {
            count: this.getResourcesByType(filteredResources, "video").length,
            resources: this.getResourcesByType(filteredResources, "video"),
          },
        };
      },

      // 從 localStorage 初始化狀態
      initFromLocalStorage() {
        // 恢復 userGroup
        const savedUserGroup = localStorage.getItem(
          "userCustomization_userGroup"
        );
        if (savedUserGroup) {
          this.userGroup = savedUserGroup;
        }

        // 恢復 selectedResource
        const savedSelectedResource = localStorage.getItem(
          "userCustomization_selectedResource"
        );
        if (savedSelectedResource) {
          try {
            this.selectedResource = JSON.parse(savedSelectedResource);
          } catch (e) {
            console.warn(
              "Failed to parse selectedResource from localStorage:",
              e
            );
          }
        }

        // 恢復 selectedB2CCategory
        const savedSelectedB2CCategory = localStorage.getItem(
          "userCustomization_selectedB2CCategory"
        );
        if (savedSelectedB2CCategory) {
          try {
            this.selectedB2CCategory = JSON.parse(savedSelectedB2CCategory);
          } catch (e) {
            console.warn(
              "Failed to parse selectedB2CCategory from localStorage:",
              e
            );
          }
        }

        // 恢復 selectedB2CResources
        const savedSelectedB2CResources = localStorage.getItem(
          "userCustomization_selectedB2CResources"
        );
        if (savedSelectedB2CResources) {
          try {
            this.selectedB2CResources = JSON.parse(savedSelectedB2CResources);
          } catch (e) {
            console.warn(
              "Failed to parse selectedB2CResources from localStorage:",
              e
            );
          }
        }

        console.log("從 localStorage 恢復狀態完成:", {
          userGroup: this.userGroup,
          selectedResource: this.selectedResource,
          selectedB2CCategory: this.selectedB2CCategory,
          selectedB2CResources: this.selectedB2CResources,
        });
      },
    },
  },
  {
    persist: true,
  }
);
